import React from 'react';
import './App.css';
import { Route, Routes, Navigate, Outlet } from "react-router-dom";
import AgeGate from './components/PageComponents/AgeGate.jsx';
import PageHeader from './components/PageComponents/PageHeader.jsx';
import PageFooter from './components/PageComponents/PageFooter.jsx';
import HomePage from './components/PageComponents/HomePage.jsx';
import XRPage from './components/PageComponents/3XRPage.jsx';
import AIPolicyPage from './components/PageComponents/AIPolicyPage.jsx';
import FAQPage from './components/PageComponents/FAQPage.jsx';
import DevlogPage from './components/PageComponents/DevlogPage.jsx';
import JobsPage from './components/PageComponents/JobsPage.jsx';
import LonelyHandsPage from './components/PageComponents/LonelyHandsPage.jsx';
import ScrollToTop from './components/ScrollToTop';

// 1. Define the Layout Component inside App or separate file
const MainLayout = () => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', backgroundColor: '#1a1a1a' }}>
      <ScrollToTop />
      <AgeGate />
      <PageHeader />
      {/* Outlet is where the child routes (Home, 3XR) will render */}
      <div style={{ flex: 1 }}> 
        <Outlet />
      </div>
      <PageFooter />
    </div>
  );
};

function App() {
  return (
    <Routes>
      {/* 2. Wrap everything in the MainLayout */}
      <Route element={<MainLayout />}>
        <Route path='/' element={<Navigate to='/home' replace />} />
        <Route path='/home' element={<HomePage />} />
        
        {/* Games Routes */}
        <Route path='/games/3xr' element={<XRPage />} />
        <Route path="/games/lonelyhands" element={<LonelyHandsPage />} />
        <Route path='/faq' element={<FAQPage />} />
        <Route path='/devlog' element={<DevlogPage />} />
        <Route path='/ai-policy' element={<AIPolicyPage />} />
        <Route path='/jobs' element={<JobsPage />} />
        {/* Fallback */}
        <Route path='*' element={<div style={{color: 'white', textAlign: 'center', marginTop: '50px'}}>404: There's nothing to see here!</div>} />
      </Route>
    </Routes>
  );
}

export default App;